module.exports = __webpack_public_path__ + "img/Weapon_146.61d92ffd.png";